<template>
  <v-row
    class="pa-0 search-result"
  >
    <v-col
      cols="12"
      sm="12"
      md="12"
      class="pl-0 pr-0"
    >
      <SearchResultItem
        v-for="sheet in sheets"
        :key="sheet.id"
        :sheet="sheet"
      />
    </v-col>
  </v-row>
</template>

<script>
import SearchResultItem from "./SearchResultItem.vue";

export default {
  name: "DaytimeAdviceSearchResultList",
  components: {
    SearchResultItem
  },
  props: {
    sheets: {
      type: Array,
      required: true
    }
  }
};
</script>
